import { styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
export const Root = styled(Card)(({ theme, fill, disabled }) => (Object.assign(Object.assign(Object.assign({ display: 'flex', flexDirection: 'column', position: 'relative', '&:hover': {
        backgroundColor: theme.palette.background.default,
        '& .contentContainer': {
            backgroundColor: theme.palette.background.default,
        },
    } }, (fill
    ? {
        height: '100%',
    }
    : {})), (disabled
    ? {
        '& > .contentContainer': {
            opacity: 0.6,
            // textDecoration: 'line-through',
        },
    }
    : {})), { '& .contentContainer': {
        display: 'flex',
        flexGrow: 1,
        '&:last-child': {
            paddingBottom: theme.spacing(2),
        },
    }, '& .contentContainerCollapsed': {
        display: 'flex',
        flexGrow: 1,
        paddingBottom: 0,
        '&:last-child': {
            paddingTop: 0,
            paddingBottom: theme.spacing(2),
        },
    }, '& .components': {
        paddingTop: 0,
        minHeight: theme.spacing(3),
    } })));
export const Icon = styled('div')(({ theme }) => ({
    marginTop: 0,
    marginRight: theme.spacing(2),
    filter: theme.palette.mode === 'dark' ? 'invert(1)' : '',
    opacity: theme.palette.mode === 'dark' ? 1 : 0.87,
    '& > img': {
        width: 70,
        height: 70,
    },
}));
export const TitleContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    flexGrow: 1,
}));
export const Titles = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginRight: theme.spacing(2),
    flexGrow: 1,
}));
export const CounterContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
}));
export const Counter = styled(Typography)(({ theme }) => ({
    marginTop: 0,
    lineHeight: 1,
    cursor: 'default',
    marginBottom: theme.spacing(0.5),
}));
export const SubCounterLabel = styled(Typography)(({ theme }) => ({
    fontSize: 14,
    whiteSpace: 'nowrap',
}));
//# sourceMappingURL=styled.js.map